// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as GAEvents from "../../../library/ga/GAEvents.bs.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as RnrRepoManager from "../domain/repo/RnrRepoManager.bs.js";
import * as RnrAssetManager from "../assets/RnrAssetManager.bs.js";
import * as RnrModalsHelper from "./helpers/RnrModalsHelper.bs.js";
import * as RnrParamsContext from "../utils/version/RnrParamsContext.bs.js";
import * as ApiUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as RnrHomeViewMapper from "./RnrHomeViewMapper.bs.js";
import * as UrlUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as ErrorUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as RescriptReactRouter from "../../../../node_modules/@rescript/react/src/RescriptReactRouter.bs.js";

var animation = RnrAssetManager.getImage("starSuccess.json");

function getInitialState(param) {
  return {
          requestStatus: /* Init */0,
          bannersStatus: /* Init */0,
          showRewardModal: RnrModalsHelper.isRewardModalVisible(undefined),
          showAwardModal: RnrModalsHelper.isAwardModalVisible(undefined),
          showConfetti: false,
          milestoneCrossed: false,
          selectedCategory: RnrModalsHelper.getRewardSelectedCategory(undefined),
          selectedDate: RnrModalsHelper.getRewardSelectedDate(undefined),
          rewardIds: /* [] */0
        };
}

function RnrHomeComponent(Props) {
  var viewModel = Props.viewModel;
  var refreshView = Props.refreshView;
  var content = Props.content;
  var rnrParams = RnrParamsContext.getRnrParams(undefined);
  var match = React.useReducer((function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* ToggleAwardModal */0 :
                  return {
                          requestStatus: state.requestStatus,
                          bannersStatus: state.bannersStatus,
                          showRewardModal: state.showRewardModal,
                          showAwardModal: !state.showAwardModal,
                          showConfetti: state.showConfetti,
                          milestoneCrossed: state.milestoneCrossed,
                          selectedCategory: state.selectedCategory,
                          selectedDate: state.selectedDate,
                          rewardIds: state.rewardIds
                        };
              case /* OnAwardClick */1 :
                  return {
                          requestStatus: state.requestStatus,
                          bannersStatus: state.bannersStatus,
                          showRewardModal: state.showRewardModal,
                          showAwardModal: true,
                          showConfetti: state.showConfetti,
                          milestoneCrossed: state.milestoneCrossed,
                          selectedCategory: state.selectedCategory,
                          selectedDate: state.selectedDate,
                          rewardIds: state.rewardIds
                        };
              case /* OnCloseRewardModal */2 :
                  return {
                          requestStatus: state.requestStatus,
                          bannersStatus: state.bannersStatus,
                          showRewardModal: false,
                          showAwardModal: state.showAwardModal,
                          showConfetti: state.showConfetti,
                          milestoneCrossed: state.milestoneCrossed,
                          selectedCategory: state.selectedCategory,
                          selectedDate: state.selectedDate,
                          rewardIds: state.rewardIds
                        };
              case /* OnCloseAwardModal */3 :
                  return {
                          requestStatus: state.requestStatus,
                          bannersStatus: state.bannersStatus,
                          showRewardModal: state.showRewardModal,
                          showAwardModal: false,
                          showConfetti: state.showConfetti,
                          milestoneCrossed: state.milestoneCrossed,
                          selectedCategory: state.selectedCategory,
                          selectedDate: state.selectedDate,
                          rewardIds: state.rewardIds
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* ToggleRewardModal */0 :
                  return {
                          requestStatus: state.requestStatus,
                          bannersStatus: state.bannersStatus,
                          showRewardModal: !state.showRewardModal,
                          showAwardModal: state.showAwardModal,
                          showConfetti: state.milestoneCrossed,
                          milestoneCrossed: state.milestoneCrossed,
                          selectedCategory: action._0,
                          selectedDate: action._1,
                          rewardIds: state.rewardIds
                        };
              case /* OnClaimReward */1 :
                  return {
                          requestStatus: {
                            TAG: /* Loading */0,
                            _0: undefined
                          },
                          bannersStatus: state.bannersStatus,
                          showRewardModal: state.showRewardModal,
                          showAwardModal: state.showAwardModal,
                          showConfetti: state.showConfetti,
                          milestoneCrossed: state.milestoneCrossed,
                          selectedCategory: state.selectedCategory,
                          selectedDate: state.selectedDate,
                          rewardIds: action._1
                        };
              case /* OnSuccess */2 :
                  var data = action._0;
                  var milestone = data.milestone;
                  var tmp;
                  if (milestone !== undefined) {
                    var award = milestone.award;
                    tmp = award !== undefined && (typeof award === "number" || award.TAG !== /* NoAward */3) ? true : false;
                  } else {
                    tmp = false;
                  }
                  return {
                          requestStatus: {
                            TAG: /* Live */1,
                            _0: data
                          },
                          bannersStatus: state.bannersStatus,
                          showRewardModal: true,
                          showAwardModal: state.showAwardModal,
                          showConfetti: state.showConfetti,
                          milestoneCrossed: tmp,
                          selectedCategory: state.selectedCategory,
                          selectedDate: state.selectedDate,
                          rewardIds: state.rewardIds
                        };
              case /* OnError */3 :
                  return {
                          requestStatus: {
                            TAG: /* Error */2,
                            _0: action._0
                          },
                          bannersStatus: state.bannersStatus,
                          showRewardModal: true,
                          showAwardModal: state.showAwardModal,
                          showConfetti: state.showConfetti,
                          milestoneCrossed: state.milestoneCrossed,
                          selectedCategory: state.selectedCategory,
                          selectedDate: state.selectedDate,
                          rewardIds: state.rewardIds
                        };
              case /* OnBannersSuccess */4 :
                  return {
                          requestStatus: state.requestStatus,
                          bannersStatus: {
                            TAG: /* Live */1,
                            _0: action._0
                          },
                          showRewardModal: state.showRewardModal,
                          showAwardModal: state.showAwardModal,
                          showConfetti: state.showConfetti,
                          milestoneCrossed: state.milestoneCrossed,
                          selectedCategory: state.selectedCategory,
                          selectedDate: state.selectedDate,
                          rewardIds: state.rewardIds
                        };
              case /* OnBannersError */5 :
                  return {
                          requestStatus: state.requestStatus,
                          bannersStatus: {
                            TAG: /* Error */2,
                            _0: action._0
                          },
                          showRewardModal: state.showRewardModal,
                          showAwardModal: state.showAwardModal,
                          showConfetti: state.showConfetti,
                          milestoneCrossed: state.milestoneCrossed,
                          selectedCategory: state.selectedCategory,
                          selectedDate: state.selectedDate,
                          rewardIds: state.rewardIds
                        };
              
            }
          }
        }), getInitialState(undefined));
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function () {
          GAEvents.publishPageView("rnr/home", "RnR Home", undefined);
          var watcherID = RescriptReactRouter.watchUrl(function (url) {
                var match = url.hash;
                switch (match) {
                  case "awards" :
                      return Curry._1(dispatch, /* ToggleAwardModal */0);
                  case "rewards" :
                      var urlParams = UrlUtils$Catalyst.getURLParams(url.search);
                      var category = RnrModalsHelper.getCategoryFromUrl(urlParams);
                      var data = RnrModalsHelper.getDateFromUrl(urlParams);
                      var date = data !== undefined ? Caml_option.valFromOption(data) : ErrorUtils$Catalyst.raiseError("RnrHomeComponent.re", "Invalid date", "");
                      return Curry._1(dispatch, {
                                  TAG: /* ToggleRewardModal */0,
                                  _0: category,
                                  _1: Caml_option.some(date)
                                });
                  default:
                    Curry._1(dispatch, /* OnCloseRewardModal */2);
                    return Curry._1(dispatch, /* OnCloseAwardModal */3);
                }
              });
          return (function (param) {
                    return RescriptReactRouter.unwatchUrl(watcherID);
                  });
        }), []);
  React.useEffect((function () {
          var match = state.requestStatus;
          var match$1 = state.showRewardModal;
          var match$2 = state.showConfetti;
          if (typeof match !== "number" && match.TAG === /* Live */1) {
            if (match$1 || match$2) {
              
            } else {
              window.history.back();
              Curry._1(refreshView, undefined);
            }
          }
          
        }), [
        state.showRewardModal,
        state.showConfetti
      ]);
  React.useEffect((function () {
          var _data = state.requestStatus;
          if (typeof _data !== "number" && _data.TAG === /* Loading */0) {
            var RepoInstance = RnrRepoManager.getRnrRepo(undefined);
            ApiUtils$Catalyst.handleAPIRequest((function (param) {
                    return Curry._4(RepoInstance.claimRnrReward, rnrParams.uuid, rnrParams.auth_token, rnrParams.lang, $$Array.of_list(state.rewardIds));
                  }), (function (data) {
                    return Curry._1(dispatch, {
                                TAG: /* OnSuccess */2,
                                _0: data
                              });
                  }), (function (message) {
                    return Curry._1(dispatch, {
                                TAG: /* OnError */3,
                                _0: message
                              });
                  }));
          }
          
        }), [state.requestStatus]);
  React.useEffect((function () {
          var RepoInstance = RnrRepoManager.getRnrRepo(undefined);
          ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._2(RepoInstance.fetchRnrBanners, rnrParams.uuid, rnrParams.auth_token);
                }), (function (data) {
                  return Curry._1(dispatch, {
                              TAG: /* OnBannersSuccess */4,
                              _0: data
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* OnBannersError */5,
                              _0: error
                            });
                }));
          
        }), []);
  return React.createElement("div", undefined, RnrHomeViewMapper.RnrHomeViewMapper.getView(viewModel, content, refreshView, state.showRewardModal, state.showAwardModal, state.showConfetti, state.selectedDate, state.selectedCategory, (function (category, date) {
                    return Curry._1(dispatch, {
                                TAG: /* ToggleRewardModal */0,
                                _0: category,
                                _1: date
                              });
                  }), (function (_uuid, rewardIds) {
                    return Curry._1(dispatch, {
                                TAG: /* OnClaimReward */1,
                                _0: rnrParams.uuid,
                                _1: rewardIds
                              });
                  }), (function (param) {
                    return Curry._1(dispatch, /* OnAwardClick */1);
                  }), state.requestStatus, state.bannersStatus));
}

var make = RnrHomeComponent;

export {
  animation ,
  getInitialState ,
  make ,
  
}
/* animation Not a pure module */
